import { render, staticRenderFns } from "./FactorInitiativesBadge.vue?vue&type=template&id=314bc4c6&scoped=true"
import script from "./FactorInitiativesBadge.vue?vue&type=script&lang=js"
export * from "./FactorInitiativesBadge.vue?vue&type=script&lang=js"
import style0 from "./FactorInitiativesBadge.vue?vue&type=style&index=0&id=314bc4c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "314bc4c6",
  null
  
)

export default component.exports